import { ParseDateToBrV2 } from 'helper/format-date-helper';
import {
  FiltersDefault,
  FilterItemInputDate,
  FilterItemInputText,
  FilterItemInputNumber,
  FilterItemInputSelect,
  FilterItemInputCheckbox,
  FilterItemInputMultiSelect,
  FilterItemInputTextList,
} from '../../../@types/interfaces/filter-interface';
import { RestUseCase } from '../../../service/api/rest/rest-usecase';

let listMesesUltimaCompra = [];
let listMesesUltimaVenda = [];
let listPontuacaoItem = [];
for (let index = 0; index <= 21; index++) {
  listPontuacaoItem.push({ label: `${index}`, value: index });
  listMesesUltimaCompra.push({ label: `${index}`, value: index });
  listMesesUltimaVenda.push({ label: `${index}`, value: index });
}

const listarDtmUltVenda = async (companyId: number) => {
  try {
    const response = await new RestUseCase(`/analise-operacional/remanejamento/data-ultima-venda/${companyId}`).Get().finally();
    return response.body.map((item: any) => ({
      label: ParseDateToBrV2(item),
      value: item,
    }));
  } catch (error) {
    console.error('Erro ao carregar Data Última Venda:', error);
    return [];
  }
};

const listarQtdMesUltVenda = async (companyId: number) => {
  try {
    const response = await new RestUseCase(`/analise-operacional/remanejamento/qtd-meses-ultima-venda/${companyId}`).Get().finally();
    return response.body.map((item: any) => ({
      label: item,
      value: item,
    }));
  } catch (error) {
    console.error('Erro ao carregar Qtd Meses Última Venda:', error);
    return [];
  }
};

const listarDtmUltCompra = async (companyId: number) => {
  try {
    const response = await new RestUseCase(`/analise-operacional/remanejamento/data-ultima-compra/${companyId}`).Get().finally();
    return response.body.map((item: any) => ({
      label: ParseDateToBrV2(item),
      value: item,
    }));
  } catch (error) {
    console.error('Erro ao carregar Data Última Compra:', error);
    return [];
  }
};

const listarQtdMesUltCompra = async (companyId: number) => {
  try {
    const response = await new RestUseCase(`/analise-operacional/remanejamento/qtd-meses-ultima-compra/${companyId}`).Get().finally();
    return response.body.map((item: any) => ({
      label: item,
      value: item,
    }));
  } catch (error) {
    console.error('Erro ao carregar Qtd Meses Última Compra:', error);
    return [];
  }
};

export const EqualizationFilterPlanningAdapter: FiltersDefault[] = [
  {
    label: 'Descrição do item',
    typeFilter: 'DESCRICAO_ITEM',
    field: [
      {
        name: 'descricao',
        typeInput: 'text',
      } as FilterItemInputText,
    ],
  },
  {
    label: 'Remanejamento Bloqueado',
    typeFilter: 'BLOQUEADO_REMANEJAMENTO',
    field: [
      {
        name: 'bloqueado',
        typeInput: 'checkbox',
        optionsInput: [
          { label: 'Bloqueado', value: true },
          { label: 'Desbloqueado', value: false },
        ],
      } as FilterItemInputCheckbox,
    ],
  },
  {
    label: 'Base',
    typeFilter: 'BASE_CODE',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Contém', value: 'IN' },
          { label: 'Não contém', value: 'NOT_IN' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'codigos',
        typeInput: 'multi-select',
        optionsInput: [], //lista de códigos do endpoint
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'Base Descrição',
    typeFilter: 'BASE_DESC',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Contém', value: 'IN' },
          { label: 'Não contém', value: 'NOT_IN' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'descricoes',
        typeInput: 'multi-select',
        optionsInput: [], //lista de descricoes do endpoint
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'Código do Item',
    typeFilter: 'CODIGO_ITEM',
    field: [
      {
        name: 'codigos',
        typeInput: 'text-list',
        separator: ';',
      } as FilterItemInputTextList,
    ],
  },
  {
    label: 'Código do Fabricante',
    typeFilter: 'CODIGO_FABRICANTE',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Contém', value: 'IN' },
          { label: 'Não contém', value: 'NOT_IN' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'codigos_fabricantes',
        typeInput: 'multi-select',
        optionsInput: [],
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'Curva Freq. e Faixa de Preço',
    typeFilter: 'CURVA_FAIXA',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Contém', value: 'IN' },
          { label: 'Não contém', value: 'NOT_IN' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'curvas',
        typeInput: 'multi-select',
        optionsInput: [
          { label: 'A', value: 'A' },
          { label: 'B', value: 'B' },
          { label: 'C', value: 'C' },
          { label: 'D', value: 'D' },
          { label: 'E', value: 'E' },
          { label: 'F', value: 'F' },
          { label: 'N', value: 'N' },
        ],
      } as FilterItemInputMultiSelect,
      {
        name: 'faixas',
        typeInput: 'multi-select',
        optionsInput: [
          { label: '1 - 250.000 à 99999999.99', value: 1 },
          { label: '2 - 70.00 à 249.99', value: 2 },
          { label: '3 - 13.00 à 69.99', value: 3 },
          { label: '4 - 0.00 à 12.99', value: 4 },
        ],
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'Filial',
    typeFilter: 'FILIAL',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Contém', value: 'IN' },
          { label: 'Não contém', value: 'NOT_IN' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'filiais',
        typeInput: 'multi-select',
        optionsInput: [],
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'UF',
    typeFilter: 'UF',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Contém', value: 'IN' },
          { label: 'Não contém', value: 'NOT_IN' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'ufs',
        typeInput: 'multi-select',
        optionsInput: [],
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'Marca',
    typeFilter: 'MARCA',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Contém', value: 'IN' },
          { label: 'Não contém', value: 'NOT_IN' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'marcas',
        typeInput: 'multi-select',
        optionsInput: [],
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'Locações',
    typeFilter: 'LOCACAO',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Contém', value: 'IN' },
          { label: 'Não contém', value: 'NOT_IN' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'locacoes',
        typeInput: 'multi-select',
        optionsInput: [],
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'Status',
    typeFilter: 'STATUS',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Contém', value: 'IN' },
          { label: 'Não contém', value: 'NOT_IN' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'status',
        typeInput: 'multi-select',
        optionsInput: [
          { label: 'Blq.Def.Asc.', value: 'Blq.Def.Asc.' },
          { label: 'Blq.Def.Desc.', value: 'Blq.Def.Desc.' },
          { label: 'Blq.Definitivo', value: 'Blq.Definitivo' },
          { label: 'Blq.Téc.Asc.', value: 'Blq.Téc.Asc.' },
          { label: 'Blq.Téc.Desc.', value: 'Blq.Téc.Desc.' },
          { label: 'Blq.Técnico', value: 'Blq.Técnico' },
          { label: 'Crítico', value: 'Crítico' },
          { label: 'Crítico Asc.', value: 'Crítico Asc.' },
          { label: 'Crítico Des.', value: 'Crítico Des.' },
          { label: 'Dem. Zero', value: 'Dem. Zero' },
          { label: 'Dem.Zero Asc.', value: 'Dem.Zero Asc.' },
          { label: 'Dm.Zero S/Vda', value: 'Dm.Zero S/Vda' },
          { label: 'Estável', value: 'Estável' },
          { label: 'Estável Asc.', value: 'Estável Asc.' },
          { label: 'Estável Des.', value: 'Estável Des.' },
          { label: 'Excesso', value: 'Excesso' },
          { label: 'Excesso Asc.', value: 'Excesso Asc.' },
          { label: 'Excesso Des.', value: 'Excesso Des.' },
          { label: 'Novo Asc.', value: 'Novo Asc.' },
          { label: 'Novo Crítico', value: 'Novo Crítico' },
          { label: 'Novo Des.', value: 'Novo Des.' },
          { label: 'Novo Premiun', value: 'Novo Premiun' },
          { label: 'Novo S/Vda', value: 'Novo S/Vda' },
          { label: 'Pleno', value: 'Pleno' },
          { label: 'Pleno Asc.', value: 'Pleno Asc.' },
          { label: 'Pleno Des.', value: 'Pleno Des.' },
        ],
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'Itens Bloqueados para Compra',
    typeFilter: 'ITEM_BLOQUEADO',
    field: [
      {
        name: 'bloqueado',
        typeInput: 'checkbox',
        optionsInput: [
          { label: 'Bloqueado', value: true },
          { label: 'Desbloqueado', value: false },
        ],
      } as FilterItemInputCheckbox,
    ],
  },
  {
    label: 'Itens com Qtd Salvas',
    typeFilter: 'ITEM_SALVO',
    field: [
      {
        name: 'salvo',
        typeInput: 'checkbox',
        optionsInput: [
          { label: 'salvo', value: true },
          { label: 'não salvo', value: false },
        ],
      } as FilterItemInputCheckbox,
    ],
  },
  {
      label: 'Data da ultima compra',
      typeFilter: 'DATA_ULTIMA_COMPRA',
      field: [
        {
          name: 'type',
          typeInput: 'select',
          optionsInput: [
            { label: 'Igual', value: 'EQUALS' },
            { label: 'Diferente', value: 'NOT_EQUALS' },
            { label: 'Maior', value: 'GREATER' },
            { label: 'Menor', value: 'LESSER' },
          ],
        } as FilterItemInputSelect,
        {
          name: 'data_ultima_compra',
          typeInput: 'multi-select',
          optionsInput: [],
          fetchOptions: listarDtmUltCompra,
        } as FilterItemInputMultiSelect,
      ],
    },
    {
      label: 'Data da última venda',
      typeFilter: 'DATA_ULTIMA_VENDA',
      field: [
        {
          name: 'type',
          typeInput: 'select',
          optionsInput: [
            { label: 'Igual', value: 'EQUALS' },
            { label: 'Diferente', value: 'NOT_EQUALS' },
            { label: 'Maior', value: 'GREATER' },
            { label: 'Menor', value: 'LESSER' },
          ],
        } as FilterItemInputSelect,
        {
          name: 'data_ultima_venda',
          typeInput: 'multi-select',
          optionsInput: [],
          fetchOptions: listarDtmUltVenda,
        } as FilterItemInputMultiSelect,
      ],
    },
  {
    //todo: ajustado pontuacao do item colocando no front, validar com o backend o envio dos dados
    label: 'Pontuação do item',
    typeFilter: 'PONTUACAO_ITEM',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Maior', value: 'GREATER' },
          { label: 'Menor', value: 'LESSER' },
          { label: 'Contém', value: 'IN' },
          { label: 'Não contém', value: 'NOT_IN' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'pontuacoes',
        typeInput: 'multi-select',
        optionsInput: listPontuacaoItem,
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'Disponibilidade em Estoque',
    typeFilter: 'ESTOQUE_DISPONIVEL',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Maior', value: 'GREATER' },
          { label: 'Menor', value: 'LESSER' },
          { label: 'Diferente', value: 'NOT_EQUALS' },
          { label: 'Igual', value: 'EQUALS' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'estoque_disponivel',
        typeInput: 'number',
      } as FilterItemInputNumber,
    ],
  },
  {
    label: 'Pendência estoque',
    typeFilter: 'PENDENCIA_ESTOQUE',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Maior', value: 'GREATER' },
          { label: 'Menor', value: 'LESSER' },
          { label: 'Diferente', value: 'NOT_EQUALS' },
          { label: 'Igual', value: 'EQUALS' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'pendencia_estoque',
        typeInput: 'number',
      } as FilterItemInputNumber,
    ],
  },
  {
    label: 'Qtd de Compra por Unidade',
    typeFilter: 'COMPRA_UNIDADE',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Maior', value: 'GREATER' },
          { label: 'Menor', value: 'LESSER' },
          { label: 'Diferente', value: 'NOT_EQUALS' },
          { label: 'Igual', value: 'EQUALS' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'compra_unidade',
        typeInput: 'number',
      } as FilterItemInputNumber,
    ],
  },
  {
    label: 'Meses da última compra',
    typeFilter: 'MESES_ULTIMA_COMPRA',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Igual', value: 'EQUALS' },
          { label: 'Diferente', value: 'NOT_EQUALS' },
          { label: 'Maior', value: 'GREATER' },
          { label: 'Menor', value: 'LESSER' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'meses_ultima_compra',
        typeInput: 'multi-select',
        optionsInput: [],
        fetchOptions: listarQtdMesUltCompra,
      } as FilterItemInputMultiSelect,
    ],
  },
  {
    label: 'Meses da última venda',
    typeFilter: 'MESES_ULTIMA_VENDA',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Igual', value: 'EQUALS' },
          { label: 'Diferente', value: 'NOT_EQUALS' },
          { label: 'Maior', value: 'GREATER' },
          { label: 'Menor', value: 'LESSER' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'meses_ultima_venda',
        typeInput: 'multi-select',
        optionsInput: [],
        fetchOptions: listarQtdMesUltVenda,
      } as FilterItemInputMultiSelect,
    ],
  },

  {
    label: 'Quantidade de excesso',
    typeFilter: 'QUANTIDADE_EXCESSO',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Maior', value: 'GREATER' },
          { label: 'Menor', value: 'LESSER' },
          { label: 'Diferente', value: 'NOT_EQUALS' },
          { label: 'Igual', value: 'EQUALS' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'quantidade_excesso',
        typeInput: 'number',
      } as FilterItemInputNumber,
    ],
  },
  {
    label: 'Custo Médio x Est',
    typeFilter: 'ESTOQUE_POR_CUSTO_MEDIO',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Maior', value: 'GREATER' },
          { label: 'Menor', value: 'LESSER' },
          { label: 'Diferente', value: 'NOT_EQUALS' },
          { label: 'Igual', value: 'EQUALS' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'custo_medio',
        typeInput: 'number',
      } as FilterItemInputNumber,
    ],
  },
  {
    label: 'Média fixa',
    typeFilter: 'MEDIA_FIXA',
    field: [
      {
        name: 'type',
        typeInput: 'select',
        optionsInput: [
          { label: 'Maior', value: 'GREATER' },
          { label: 'Menor', value: 'LESSER' },
          { label: 'Diferente', value: 'NOT_EQUALS' },
          { label: 'Igual', value: 'EQUALS' },
        ],
      } as FilterItemInputSelect,
      {
        name: 'media_fixa',
        typeInput: 'number',
      } as FilterItemInputNumber,
    ],
  },
];
